import { useTranslation } from 'react-i18next'
import { useTheme, type ThemePreference } from '../theme/ThemeContext'

const ORDER: ThemePreference[] = ['system', 'light', 'dark']

export function ThemeSwitcher() {
  const { t } = useTranslation()
  const { preference, cycle } = useTheme()

  return (
    <button
      type="button"
      onClick={cycle}
      className="rounded border px-3 py-1 text-sm"
      style={{
        borderColor: 'var(--color-border)',
        background: 'transparent',
        color: 'var(--color-fg)',
      }}
      aria-label={`${t('theme.label')}: ${t(`theme.${preference}`)} (cycles to ${t(`theme.${ORDER[(ORDER.indexOf(preference) + 1) % ORDER.length]}`)})`}
    >
      {t('theme.label')}: {t(`theme.${preference}`)}
    </button>
  )
}
